module.exports = __webpack_public_path__ + "img/video.9d5b644b.png";